<template>
  <router-link to="/" class="brand-logo">
    <div v-if="!domainBasedBrand">
      <img class="img-fluid light-logo" src="/images/logo-w.png" alt="" />
    </div>
    <div v-else>
      <img
        class="img-fluid logo-image-header short-logo"
        :src="
          currentBrand.web_logo_issqr
            ? currentBrand.web_logo_sqr
            : currentBrand.web_logo
        "
        :style="{
          borderRadius:
            currentBrand.web_logo_issqr && $route.name === 'home'
              ? '50%'
              : null,
        }"
      />
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'brand_logo',
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand', 'currentBrand']),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .brand-logo {
    margin-right: unset !important;
    margin-left: $px12;
  }
}
.brand-logo {
  margin-right: auto;
  max-height: $px50;
  z-index: 2;
  &.center-logo {
    position: absolute;
    margin-right: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-left: auto;
  }
  .img-fluid {
    max-width: $px150 !important;
    height: auto !important;
    cursor: pointer;
    @media (max-width: 575px) {
      border-radius: 7%;
    }
  }
  .short-logo {
    display: flex;
    max-width: $px150 !important;
    max-height: auto !important;
    overflow: auto;
  }
}
</style>
